import { render, staticRenderFns } from "./IbxAppHeaderViewOnlyBanner.vue?vue&type=template&id=abb6c5c2&scoped=true"
import script from "./IbxAppHeaderViewOnlyBanner.vue?vue&type=script&lang=js"
export * from "./IbxAppHeaderViewOnlyBanner.vue?vue&type=script&lang=js"
import style0 from "./IbxAppHeaderViewOnlyBanner.vue?vue&type=style&index=0&id=abb6c5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb6c5c2",
  null
  
)

export default component.exports